module.exports = __webpack_public_path__ + "static/media/horsecow.0dbda755.jpg";